// Назначения ролей (contracts/api.md 001, 040, 041: без областей и замещения).
import { z } from '../kernel/zod.ts';
import { AssignmentSchema } from '../access/assignment.ts';
import { fieldMessages } from '../kernel/field-messages.ts';
import { RoleInputSchema } from '../rights/roles.ts';

/** Даты по порядку; ISO-даты сравниваются как строки. */
export function datesInOrder(
  from: string | null | undefined,
  to: string | null | undefined,
): boolean {
  return from == null || to == null || from <= to;
}

/**
 * POST /api/assignments (040, FR-003; 041, FR-011): назначаются только «Администратор»
 * и сопровождение, во всей установке. Срок вручную не задаётся (041, research Р6): validFrom
 * и validTo отклоняются, как любое лишнее поле (REC-007).
 */
export const CreateAssignmentBodySchema = z.strictObject({
  userId: z.uuid({ error: fieldMessages.user }),
  role: RoleInputSchema,
});
export type CreateAssignmentBody = z.input<typeof CreateAssignmentBodySchema>;

/**
 * PATCH /api/assignments/{id} с If-Match: роль. Срок вручную не задаётся (041, research Р6) —
 * validFrom и validTo отклоняются (REC-007).
 */
export const UpdateAssignmentBodySchema = z.strictObject({
  role: RoleInputSchema.optional(),
});
export type UpdateAssignmentBody = z.input<typeof UpdateAssignmentBodySchema>;

export const AssignmentListSchema = z.array(AssignmentSchema);

/**
 * POST /api/assignments/{id}/archive и /restore (T144): If-Match — версия назначения, которую
 * видел пользователь, когда нажал «Снять роль» или «Вернуть». Устаревшая — 409 REC-001 с текущим
 * назначением и последним изменением (FR-028). Без заголовка версия не сверяется: архив и возврат
 * повторяемы — уже снятую роль второй раз не снимают.
 */
export const AssignmentVersionHeadersSchema = z.object({
  'if-match': z.coerce.number().int().min(1).optional(),
});
